<template>
<div class="modal-content golf-stickynote-master">
    <div class="modal-body">
        <div v-show="selectedTeeTimes.length > 0">
            <div class="pull-right">
                <span>{{ selectedTeeTimes.length }} {{ $_locale('tee times selected', false) }}.</span>
            </div>
            <h4>{{ $_locale('move reservations') }}</h4>
            <golf-reservation-modifier 
                ref="massReservationModifier"
                :defaultResourceId="resourceId"
                :defaultDate="selectedTeeTimes[0].start" />
            <p>{{ $_locale('reservations will be moved starting from the time that is set above') }}</p>
        </div>
    </div>
    <div class="modal-footer">
        <div style="display: flex;">
            <button class="btn btn-default btn-sm" @click="$emit('deselect')" style="margin-right: auto;">{{ $_locale('cancel') }}</button>
            <button class="btn btn-danger" @click="deactivateReservations">{{ $_locale('delete') }}</button>
        </div>
        <button class="btn btn-success btn-sm btn-block" @click="saveReservations">{{ $_locale('save') }}</button>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import GolfReservationModifier from './GolfReservationModifier.vue'

export default {
    props: {
        resourceId: {
            type: Number,
            required: true,
        }
    },
    components: {
        GolfReservationModifier
    },
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            selectedTeeTimes: 'golf/selectedTeeTimes',
            service: 'reservations/service',
            date: 'reservations/date',
        }),
        startTime() {
            return this.selectedTeeTimes.reduce((acc, curr) => {
                if (acc === null) return curr.start;

                return curr.start < acc ? curr.start : acc;
            }, null)
        },
        reservations() {
            return this.selectedTeeTimes
            .reduce((acc, curr) => {
                return [ ...acc, ...curr.reservations ];
            }, [])
            .sort((a, b) => new Date(a.start) > new Date(b.start) ? 1 : -1)
        },
    },
    watch: {
        'selectedTeeTimes.length': {
            deep: true,
            immediate: true,
            handler(val) {
                if (val < 1) return;
                
                this.$nextTick(() => this.setStartTime());
            }
        }
    },
    methods: {
        setStartTime() {
            const modifier = this.$refs.massReservationModifier;
            
            modifier.setStartTime(this.selectedTeeTimes[0].start);
        },
        saveReservations() {
            const reservationLength = this.service.getBlockTotalLength();
            const modifier = this.$refs.massReservationModifier;
            const first = modifier.formatReservation(this.reservations[0]);
            const transFormTimes = {};

            this.selectedTeeTimes.forEach((row, i) => {
                const dateTime = moment(row.start).format('YYYY-MM-DD HH:mm:ss')

                if (i == 0) {
                    transFormTimes[dateTime] = moment(first.dateTimeStart).format('YYYY-MM-DD HH:mm:ss');
                } else {
                    transFormTimes[dateTime] = moment(first.dateTimeStart)
                        .add(i * reservationLength, 'minutes')
                        .format('YYYY-MM-DD HH:mm:ss');
                }
            })

            const dataRows = this.reservations.map((row, i) => {
                const newDateTime = transFormTimes[row.start];

                modifier.setStartTime(newDateTime, false);

                return modifier.formatReservation(row);
            })

            this.$emit('deselect');
            
            Promise.all(
                dataRows.map(row => this.saveEditedReservation(row))
            )
            .then((result) => {
                const success = result.filter(row => !row.data.success).length === 0;

                if (success) {
                    this.$store.dispatch('reservations/onDateChange', this.date)

                    this.$_swal({ icon: 'success', title: _locale('reservation saved').ucfirst() })
                } else {
                    const message = result.filter(row => !!row.data.message)
                    .reduce(
                        (prev, curr) => {
                            return [
                                ...prev,
                                curr.data.message
                            ]
                        }, 
                        []
                    )
                    this.$_swal({ icon: 'error', title: message.join("\n") })
                }
            })
        },
        saveEditedReservation(data) {
            const EcomService = this.$store.getters['ecom/EcomService'];

            return EcomService.editReservationTime(data);
        },
        deactivateReservations() {
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const dataRows = this.reservations.map(row => row.reservationTimeId);

                    this.$emit('deselect');

                    this.deactivateReservationTime(dataRows)
                    .then((response) => {
                        const { data } = response;

                        if (data.success) {
                            this.$store.dispatch('reservations/onDateChange', this.date);
                            
                            this.$_swal({ icon: 'success', title: _locale('deleted').ucfirst() })
                        } else if (typeof data.message === 'string') {
                            this.$_swal({ icon: 'error', title: data.message })
                        }
                    })
                }
            })
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            return EcomService.deactivateReservationTime(reservationTimeId)
        },
    },
}
</script>

<style lang="scss">
.golf-stickynote-master {
    position: sticky;
    bottom: 15px;
    width: 600px;
    max-width: 90%;
    min-height: 60px;
    margin: auto;
    z-index: 10;
}
</style>